<template>
  <ca-modal
    ref="modal"
    size="small"
    :title="titleModal">
    <template slot="body">
      <recalculate-box-information />
    </template>

    <ca-row slot="footer">
      <ca-col size="3">
        <ca-button full-width @click="onCancel">
          Fechar
        </ca-button>
      </ca-col>
      <ca-col offset="6" size="3">
        <ca-button
          theme="primary"
          full-width
          @click="onConfirm">
          Confirmar
        </ca-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
import moment from 'moment';
import RecalculateBoxInformation from './RecalculateBoxInformation';

export default {
  name: 'Modal',
  components: {
    RecalculateBoxInformation,
  },
  props: {
    period: String,
    title: String,
  },
  computed: {
    titleModal() {
      return this.period
        ? `${this.title} ${moment(this.period, 'DD/MM/YYYY').format('MMMM/YYYY')}`
        : this.title;
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
      this.$refs.modal.close();
    },
    onCancel() {
      this.$emit('cancel');
      this.$refs.modal.close();
    },
  },
};
</script>
